import React from "react";
import styles from "./CartSuccessPage.module.css";
import PropTypes from "prop-types";
import { CartSuccess } from "components/Cart";
import { useRouteMatch } from "react-router-dom";

function CartSuccessPage(props) {
  const match = useRouteMatch();

  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <CartSuccess idCart={match.params.success} />
      </div>
    </section>
  );
}

CartSuccessPage.propTypes = {};

export default CartSuccessPage;
